import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer";
import Navbar from "../../Components/Header";
import PortfolioWebCard from "../../Components/PortfolioWebCard";
import Pricing from "../../Components/PricingTable";
import WebServices from "../../Components/WebCards";
import bgplans from "../../Images/Frame.png";
import bgwhite from "../../Images/Framemission.png";
import graphicservice from "../../Images/Graphics PNG/work.png";
import bgteal from "../../Images/tealback.png";
import one from "../../Images/WebPortfolio/01.jpg";
import two from "../../Images/WebPortfolio/02.jpg";
import three from "../../Images/WebPortfolio/03.jpg";
import four from "../../Images/WebPortfolio/04.jpg";
import five from "../../Images/WebPortfolio/05.jpg";
const words = ["Unique", "High-Quality", "Specialized", "Exclusive"];

const Web = () => {
  const [currentWord, setCurrentWord] = useState(0);
  const [animate, setAnimate] = useState(false);
  const projects = [
    {
      name: "Iposb Logistics",
      tags: ["Reels", "Smooth Transitions", "Subtitles"],
      img: one,
    },
    {
      name: "Abdul Kareem khan",
      tags: ["Long Form Videos", "Color Grading", "Sound Design"],
      img: two, // replace with actual video path
    },
    {
      name: "Beauty and Brands",
      tags: ["Motion Graphics", "Infographics", "Data Visualization"],
      img: three, // replace with actual video path
    },
    {
      name: "Applique",
      tags: ["Creative Ads", "Thumbnails", "Smooth Transitions"],
      img: four, // replace with actual video path
    },
    {
      name: "Codrivity",
      tags: ["Green Screen", "AI Voiceovers", "Motion Graphics"],
      img: five, // replace with actual video path
    },
  ];

  const plans = [
    {
      name: "Basic",
      features: [
        "A fully responsive 3-5 page static website, custom-coded.",
        "Responsive Design: Ensures the website is fully optimized for desktop, tablet, and mobile devices.",
        "Deployment Assistance: Help with deploying the static site to your chosen hosting platform (Netlify, GitHub Pages, etc.).",
      ],
    },
    {
      name: "Standard",
      features: [
        "A 7-10 page web application with dynamic functionality, using front-end frameworks.",
        "Backend Integration: Basic server-side setup.",
        "Database Connectivity: Integration of a database (e.g., MongoDB, MySQL) for content management, user data, or product catalogues.",
        "API Integration: Integration with external APIs (e.g., payment gateways, social media, maps).",
        "Deployment Support: Deployment on platforms like Vercel, Netlify (no setup required).",
      ],
    },
    {
      name: "Premium",
      features: [
        "Includes an unlimited number of pages and features.",
        "Advanced Backend: Custom backend logic with complex features, using robust frameworks like Node.js.",
        "Custom Database Architecture: Design and implementation of scalable databases (SQL/NoSQL) to handle large volumes of data and users.",
        "Real-Time Features: Implementation of real-time functionalities like live chat, notifications, or collaborative tools using WebSockets.",
        "Ongoing Maintenance & Updates: Continuous support with regular updates, security patches, and performance monitoring.",
        "Custom Infrastructure Deployment: Deployment on EC2, Heroku, etc. (setup required).",
      ],
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(true);

      setTimeout(() => {
        setCurrentWord((prevWord) => (prevWord + 1) % words.length);
        setAnimate(false);
      }, 500);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className=" md:overflow-y-scroll  lg:h-screen md:h-screen lg:overflow-y-scroll">
      <div className=" md:h-screen lg:h-screen">
        <div className="">
          <Navbar color={"bg-teal-950 text-white"} />
        </div>

        {/* Animated Text Section */}
        <div className=" flex flex-col justify-between pb-10 lg:pb-0 md:pb-0">
          <div className="max-w-7xl  mx-auto px-8 lg:px-8 flex flex-col md:flex-row lg:flex-row gap-8 lg:pb-20 lg:pt-10">
            {/* Left Side: Text Section */}
            <div className="flex flex-col justify-center  w-full lg:w-1/2 md:w-1/2 mt-6 md:mt-6 lg:mt-10">
              <h1 className="relative h-12 mb-2 md:mb-4 lg:mb-4">
                <span
                  className={`absolute transition-transform duration-500 ease-in-out  text-2xl md:text-3xl lg:text-4xl font-bold text-teal-500`}
                >
                  {words[currentWord]}
                </span>
              </h1>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-teal-800">
                Website development and Design
              </h2>
              <p className="text-gray-600 mb-8 text-md md:text-lg lg:text-lg">
                Ignite the force of visual storytelling, from bespoke
                illustrations to captivating infographics, our talented artists
                sculpt mesmerizing designs that deeply connect with your
                audience and amplify your brand's message.
              </p>
            </div>

            {/* Right Side: Image Section */}
            <div className="hidden md:flex lg:flex flex-col lg:flex-row md:flex-row justify-center items-center lg:justify-end w-full lg:w-1/2 md:w-1/2 mt-10 md:mt-0 lg:mt-0 xl:mt-0">
              <img
                src={graphicservice}
                alt="Illustration Design"
                className="w-[350px] h-[250px] md:w-[450px] md:h-[380px] lg:w-[550px] lg:h-[500px]"
              />
            </div>
          </div>
        </div>
      </div>
      {/* Navbar */}

      {/* Numbered Cards Section */}
      <div
        className="  lg:h-screen bg-white p-2 m-auto flex items-center justify-center"
        style={{
          backgroundImage: `url(${bgwhite})`,
          backgroundSize: "cover",
          backgroundPosition: "top left",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed", // Fix background movement
        }}
      >
        <WebServices />
      </div>

      {/* Portfolio Section */}
      <div
        className=" px-1 md:px-8 lg:px-8 flex flex-col gap-8 text-white py-16"
        style={{
          backgroundImage: `url(${bgteal})`,
          backgroundSize: "cover",
          backgroundPosition: "top left",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed", // Fix background movement
        }}
      >
        <div className="overflow-hidden">
          <div className="mt-12 max-w-7xl mx-auto px-8 bg-transparent">
            <h2 className="text-center text-3xl md:text-4xl lg:text-5xl font-bold mb-10 text-white">
              Our Work Portfolio
            </h2>
            <p className="text-center text-normal font-md text-lg mb-12 text-teal-50">
              Explore our diverse portfolio showcasing creative and innovative
              web development solutions tailored to bring your vision to life.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-4 lg:gap-8">
              {projects.map((project, index) => (
                <PortfolioWebCard
                  key={index}
                  projectName={project.name}
                  tags={project.tags}
                  img={project.img}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Pricing Section */}
      <div className="">
        <div
          className="w-full  mx-auto  "
          style={{
            backgroundImage: `url(${bgplans})`,
            backgroundSize: "cover",
            backgroundPosition: "top left",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed", // Fix background movement
          }}
        >
          <Pricing plans={plans} />
        </div>
      </div>

      {/* Footer */}
      <div className="">
        <Footer />
      </div>
    </div>
  );
};

export default Web;
